export const FETCH_EVENTS_LOADING = 'FETCH_EVENTS_LOADING';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_ERROR = 'FETCH_EVENTS_ERROR';
export const FILTER_BY_DATE = 'FILTER_BY_DATE';
export const FILTER_BY_EMAIL = 'FILTER_BY_EMAIL';
export const UPCOMING_EVENTS = 'UPCOMING_EVENTS';
export const PAST_EVENTS = 'PAST_EVENTS';
export const DETAILS_VIEW = 'DETAILS_VIEW';
export const CANCEL_DATE_FILTER = 'CANCEL_DATE_FILTER';
export const EVENT_OTHER_FILTERS = 'EVENT_OTHER_FILTERS';
export const FILTER_BY_EVENT_TYPES = 'FILTER_BY_EVENT_TYPES';
export const FILTER_BY_USERS = 'FILTER_BY_USERS';
export const APPLY_USER_FILTER = 'APPLY_USER_FILTER';
export const APPLY_DATE_FILTER = 'APPLY_DATE_FILTER';
export const APPLY_EMAIL_FILTER = 'APPLY_EMAIL_FILTER';
export const ON_FILTER_CHANGE = 'ON_FILTER_CHANGE';
export const ON_CALENDAR_CHANGE = 'ON_CALENDAR_CHANGE';
export const APPLY_EVENT_FILTER = 'APPLY_EVENT_FILTER';
export const ON_CANCEL_EVENT = 'ON_CANCEL_EVENT';
export const ON_DETAIL_EXPAND = 'ON_DETAIL_EXPAND';
export const ON_CHANGE_ACTIVE_TAB = 'ON_CHANGE_ACTIVE_TAB';
export const RESET_FILTER = 'RESET_FILTER';
export const ON_PAGE_CHANGE = 'ON_PAGE_CHANGE';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_EVENT_LIST_SUCCESS = 'FETCH_EVENT_LIST_SUCCESS';
